export default "__VITE_ASSET__odvIwQoL__"